export default __webpack_public_path__ + "locales/lo-LA/DeleteProfileEverDialog.json?hash=3dc03e7d77cc7789029d93dfc6c75a20";